import slide1 from './assets/1-large.webp';
import slide2 from './assets/2-large.webp';
import slide3 from './assets/3-large.webp';
import slide4 from './assets/4-large.webp';
import thumb1 from './assets/1-mini.webp';
import thumb2 from './assets/2-mini.webp';
import thumb3 from './assets/3-mini.webp';
import thumb4 from './assets/4-mini.webp';

export const halfSliderContent = {
  slides: [
    {
      title: ['первая линия', 'Камы'],
      thumbnail: thumb1,
      photo: slide1,
      descriptionAccent: 'Отправляйтесь на рыбалку\nили прогулку',
      description: 'на сапах, купайтесь\nлетом и заряжайтесь спокойствием',
    },
    {
      title: ['термы', 'baden-baden'],
      thumbnail: thumb2,
      photo: slide2,
      descriptionAccent: 'масштабный термальный курорт\nс открытыми бассейнами',
      description: ' — будет \nпостроен в 5 минутах от комплекса',
    },
    {
      title: ['собственная', 'набережная'],
      thumbnail: thumb3,
      photo: slide3,
      descriptionAccent: 'в рамках проекта \nмы реализуем приватный променад, ',
      description:
        'отделенный от общественной зоны',
    },
    {
      title: ['Крупные', 'ТЦ центра'],
      thumbnail: thumb4,
      photo: slide4,
      descriptionAccent: 'IMall и «Колизей Cinema»',
      description:
        '\nнаходятся в 8 минутах езды на авто',
    },
  ],
};
